import type { Listing } from '@shared/types';

/** Prefer root slug URL when slug is set (e.g. /bronze-bay-17); else /listing/{id} */
export function getListingPath(listing: Pick<Listing, 'id' | 'slug'>): string {
  const s = listing.slug?.trim();
  if (s && /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(s)) {
    return `/${encodeURIComponent(s.toLowerCase())}`;
  }
  return `/listing/${listing.id}`;
}

export function getListingPublicUrl(listing: Pick<Listing, 'id' | 'slug'>): string {
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}${getListingPath(listing)}`;
}
